import { Distributor } from "./Distributor";
import { Guid } from "./Guid";
//import { ProjectHeader } from "./ProjectHeader";

export class User {
  constructor() {
    this.DefaultUOM = "ENGLISH";
    this.Password = "";
    this.UserId = Guid.newGuid();
    this.FirstName = "";
    this.LastName = "";
    this.Role = "inactive";
    this.SolidType = "sldasm";
    this.DeliveryType = "http";
    this.IsTolomaticUser = false;
  }

  BuildUser(user: User) {
    this.DefaultUOM = user.DefaultUOM;
    this.Password = "";
    this.UserId = user.UserId;
    this.FirstName = user.FirstName;
    this.LastName = user.LastName;
    this.Role = user.Role;
    this.SolidType = user.SolidType;
    this.DeliveryType = user.DeliveryType;
    this.Email = user.Email;
    this.CreatedBy = user.CreatedBy;
    this.UpdatedBy = user.UpdatedBy;
    this.ResetPassword = user.ResetPassword;
    this.IsTolomaticUser = user.IsTolomaticUser;
    this.DistributorId = user.DistributorId;
    this.City = user.City;
    this.State = user.State;
    this.ZipCode = user.ZipCode;
    if (user.Distributor) {
      this.Distributor = new Distributor().BuildDistributor(user.Distributor);
    }    
    this.Company = user.Company;
    this.Phone = user.Phone;
    return this;
  }

  UserId: Guid;
  Email: string;
  Password: string;
  FirstName: string;
  LastName: string;
  //ProjectLines: ProjectHeader[];
  CreatedBy: string;
  UpdatedBy: string;
  ResetPassword: boolean;
  IsTolomaticUser: boolean;
  DistributorId: string;
  DefaultUOM: string;
  City: string;
  State: string;
  ZipCode: string;
  Role: string;
  Distributor: Distributor;
  SolidType: string;
  DeliveryType: string;
  Address1: string;
  Address2: string;
  Phone: string;
  Company: string;
  Country: string;

  HasPagePermission(page: string):boolean {
    if (this.IsTolomaticUser || this.Distributor.Permissions.filter(x => x.Page.toLowerCase() == page.toLowerCase()).length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  HasPageActionPermission(page: string, action: string):boolean {
    if (this.IsTolomaticUser || this.Distributor.Permissions.filter(x => x.Page.toLowerCase() == page.toLowerCase() && x.Action.toLowerCase() == action.toLowerCase()).length > 0) {
      return true;
    }
    else {
      return false;
    }
  }
}
